import { render, staticRenderFns } from "./RequestAlert.vue?vue&type=template&id=3e212686"
import script from "./RequestAlert.vue?vue&type=script&lang=js"
export * from "./RequestAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports